/*
 * @Author: zhao - 🍉
 * @Date: 2022-02-14 20:55:00
 * @LastEditTime: 2022-02-14 23:09:45
 * @LastEditors: zhao - 🍉
 * @Description: 收房合同房租周期 - 编辑
 * @FilePath: /zhzj-admin/src/page/RentCycle/update.jsx
 */


import {Modal, Input, message, Select} from 'antd';
import React, { useState, useRef } from 'react'
import { CustomCol, CustomRow } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import GroupForm from '../../components/GroupForm';
import ModalScrollContainer from '../../components/ModalScrollContainer';
import { fetchRentCycleAdd, fetchRentCycleGet, fetchRentCycleUpdate } from '../../services/rentCycle';
import {paymentDate} from "../../axios/dictionaries";
const Option = Select.Option;
const RentCycleUpdate = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const [id, setId] = useState(null);
    const [buildingId, setBuildingId] = useState(null);
    let monitor = useRef(null)
    const open = (buildingId,_id) => {
        setBuildingId(buildingId)
        setVisible(true)
        setId(_id || null)
        if (_id) {
            postRentCycleGet({id: _id})
        } else {
            setDetailData({})
        }
        return new Promise((resolve, reject) => {
            monitor.current = resolve
        })
    }
    const close = () => {
        setVisible(false)
    }
    const postRentCycleGet = (data) => {
        setLoading(true)
        fetchRentCycleGet(data).then(res => {
            setDetailData(res || {})
        }).finally(() => {
            setLoading(false)
        })
    }
    const postSubmit = (data) => {
        const post = id ? fetchRentCycleUpdate : fetchRentCycleAdd
        data.id = id || undefined
        data.buildingId = buildingId
        setLoading(true)
        return post(data).then(res => {
            message.success('保存成功')
        }).finally(() => {
            setLoading(false)
        })
    }
    const handleSetFormData = (data = {}) => {
        setDetailData({...detailData, ...data})
    }
    const handleSubmit = () => {
        if (!detailData.rent){
            detailData.rent=0;
        }
        if (!detailData.cycleStart) return message.warning('请输入周期开始期数')
        if (!detailData.cycleEnd) return message.warning('请输入周期结束期数')
        if (!detailData.payeeMerchantList) return message.warning('请输入业主租金配置')
        if (!detailData.executionDay) return message.warning('请选择执行日')
        for (let i = 0; i< detailData.payeeMerchantList.length; i++) {
            const current = detailData.payeeMerchantList[i]
            if(!current.rent){
                current.rent = 0;
            }
            if (!current.owner || !current.enterpriseUserNumber) {
                return  message.warning('请完成业主租金配置')
            }
        }
        
        postSubmit(detailData).then(() => {
            close()
            monitor.current()
        })
    }

    props.getRef && props.getRef({ open });
    const columns = [
        { title: '业主名称', dataIndex: 'owner', width: 150, type: 'input',  },
        { title: '银联企业用户号', dataIndex: 'enterpriseUserNumber', width: 150, type: 'input',  },
        { title: '租金', dataIndex: 'rent', width: 150, type: 'number',  },
    ]
    return (
        <Modal 
            title="收房合同房租周期" 
            width={950} 
            visible={visible} 
            onOk={handleSubmit}
            confirmLoading={loading}
            onCancel={close} 
        >
            <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>

                <div className="custom" >
                    <DetailTitle title="周期配置" />
                    <CustomRow>
                        <CustomCol label="租金">
                            <Input value={detailData.rent} onChange={(e) => handleSetFormData({rent: e.target.value})} />
                        </CustomCol>
                        <CustomCol label="周期开始期数">
                            <Input value={detailData.cycleStart} onChange={(e) => handleSetFormData({cycleStart: e.target.value})} />
                        </CustomCol>
                        <CustomCol label="周期结束期数">
                            <Input value={detailData.cycleEnd} onChange={(e) => handleSetFormData({cycleEnd: e.target.value})} />
                        </CustomCol>

                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="执行日">
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                    style={{width: "100%"}}
                                    value={detailData.executionDay}
                                    onChange={(e) => {
                                        handleSetFormData({executionDay: e})
                                    }}
                                >
                                    {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                </Select>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="业主租金配置" />
                    <GroupForm columns={columns} value={detailData.payeeMerchantList || []} onChange={(e) => handleSetFormData({ payeeMerchantList: e })} />
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}


export default RentCycleUpdate


// WEBPACK FOOTER //
// ./src/page/RentCycle/update.jsx